export default __webpack_public_path__ + "static/media/ig.2c7b68ee.jpg";